import { plugin, debug } from 'light-component';
import dayjs from 'dayjs';
import { useEffect, useState, type ReactElement } from 'react';
import * as Base from '@base';
import { t } from '@common';
import { Require } from '../component';
import styles from './style.module.less';
import type { Dayjs } from 'dayjs';
import type { MonthRangeProps } from './types';

export function WidgetMonthRange(props: MonthRangeProps): ReactElement {
  debug.widget('dashboard month range', props);
  const { allowClear = true } = props;
  const [dates, setDates] = useState<[(Dayjs | null), (Dayjs | null)]>([null, null]);
  const [maxDate, setMaxDate] = useState<Dayjs>();

  useEffect(() => {
    if (props.maxDate == null) {
      return;
    }
    props.maxDate === '$now' ? setMaxDate(dayjs()) : setMaxDate(dayjs(props.maxDate));
  }, [props.maxDate]);

  useEffect(() => {
    const [start, end] = props.value ?? [null, null];
    const startDate = typeof (start) === 'string' ? dayjs(start) : start;
    const endDate = typeof (end) === 'string' ? dayjs(end) : end;
    if (startDate != null && endDate != null && startDate.isAfter(endDate)) {
      setDates([endDate, startDate]);
      return;
    }
    setDates([startDate, endDate]);
  }, [props.value]);

  function disabledDate(current: Dayjs): boolean {
    const [start, end] = dates;
    if (start == null && end == null) return false;
    if (start != null && current.diff(start, 'days') > props.maxRange) {
      return true;
    }
    if (end != null && current.diff(end, 'days') < (0 - props.maxRange)) {
      return true;
    }
    return false;
  }

  // 监听日期选择器的日历变化
  function onCalendarChange(dates: (Dayjs | null)[]): void {
    const [start, end] = dates ?? [null, null];
    const startDate = start != null ? dayjs(start).format('YYYY-MM') : start;
    const endDate = end != null ? dayjs(end).format('YYYY-MM') : end;
    props.onChange?.([startDate, endDate]);
  }

  return (
    <div className={props.className}>
      <div className={styles.input}>
        <Require require={props.require} />
        <span className={styles.title}>{t(props.title ?? '')}</span>
      </div>
      <Base.DatePicker.RangePicker
        className={styles.treeSelect}
        placeholder={[t('开始月份'), t('结束月份')]}
        allowEmpty
        allowClear={allowClear}
        disabled={props.disabled}
        value={dates}
        picker="month"
        disabledDate={disabledDate}
        onCalendarChange={onCalendarChange}
        maxDate={maxDate}
      />
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'monthRange', component: WidgetMonthRange });
